import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import check from "../../assets/svgs/single-check.svg";
import "./PaymentMethod.css";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";

const PAYMENT_OPTIONS = [
  {
    id: 1,
    key: "Rapyd",
    label: "Credit / Debit Card",
    description: "Visa, Mastercard, Amex & more",
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
        <line x1="1" y1="10" x2="23" y2="10" />
      </svg>
    ),
  },
  // {
  //   id: 2,
  //   key: "cash",
  //   label: "Cash",
  //   description: "Pay in person upon delivery",
  //   icon: (
  //     <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
  //       stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
  //       <rect x="2" y="6" width="20" height="12" rx="2" />
  //       <circle cx="12" cy="12" r="3" />
  //       <path d="M6 12h.01M18 12h.01" />
  //     </svg>
  //   ),
  // },
];

const PaymentMethod = (props) => {
  const [activePayment, setActivePayment] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState(null);

  useEffect(() => {
    if (props.outletInfo?.method === 1) {
      setActivePayment(0);
      setPaymentMethod(null);
    }
  }, [props.outletInfo?.out_id]);

  const handleSelect = (option) => {
    setActivePayment(option.id);
    setPaymentMethod(option.key);
  };

  const handleProceed = () => {
    if (!paymentMethod) return;
    props.setPaymentMethod(paymentMethod);
    props.setPaymentVisible();
  };

  if (props.outletInfo?.method !== 2) return null;

  return (
    <Modal
      show={props.showPayment}
      onHide={() => props.setPaymentVisible(false)}
      className="pm-modal"
      dialogClassName="pm-dialog"
      contentClassName="pm-content"
      centered
      backdrop="static"
    >
      {/* Header */}
      <div className="pm-header">
        <div className="pm-header-left">
          <div className="pm-header-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
              <line x1="1" y1="10" x2="23" y2="10" />
            </svg>
          </div>
          <div>
            <h5 className="pm-title">Payment Method</h5>
            <p className="pm-subtitle">Choose how you'd like to pay</p>
          </div>
        </div>
        <ModalCloseButton
          onClick={() => props.setPaymentVisible(false)}
          style={{ position: "static", width: "32px", height: "32px" }}
        />
      </div>

      {/* Body */}
      <Modal.Body className="pm-body">
        <div className="pm-options">
          {PAYMENT_OPTIONS.map((option) => {
            const isActive = activePayment === option.id;
            return (
              <button
                key={option.id}
                className={`pm-option${isActive ? " pm-option--active" : ""}`}
                onClick={() => handleSelect(option)}
              >
                <div className={`pm-option-icon${isActive ? " pm-option-icon--active" : ""}`}>
                  {option.icon}
                </div>
                <div className="pm-option-text">
                  <span className="pm-option-label">{option.label}</span>
                  <span className="pm-option-desc">{option.description}</span>
                </div>
                <div className={`pm-option-check${isActive ? " pm-option-check--active" : ""}`}>
                  {isActive && <img src={check} alt="selected" className="pm-check-img" />}
                </div>
              </button>
            );
          })}
        </div>

        {/* Selected Summary */}
        {paymentMethod && (
          <div className="pm-summary">
            <span className="pm-summary-label">Selected:</span>
            <span className="pm-summary-value">
              {PAYMENT_OPTIONS.find((o) => o.key === paymentMethod)?.label}
            </span>
          </div>
        )}
      </Modal.Body>

      {/* Footer */}
      <div className="pm-footer">
        <button
          className="pm-cancel-btn"
          onClick={() => props.setPaymentVisible(false)}
        >
          Cancel
        </button>
        <button
          className={`pm-proceed-btn${!paymentMethod ? " pm-proceed-btn--disabled" : ""}`}
          onClick={handleProceed}
          disabled={!paymentMethod}
        >
          Proceed
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </button>
      </div>
    </Modal>
  );
};

export default PaymentMethod;